import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-precetto-view',
  templateUrl: './form-precetto-view.component.html',
  styleUrls: ['./form-precetto-view.component.css']
})
export class FormPrecettoViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
